import React, {useState, useEffect} from 'react';
import { useTranslation } from 'react-i18next';
import { bookingFinal }  from "./server/bookingFinal";
import EMDBcart from  '../../utils/emdb.cart.js'

//CSS
import styles from './VTCartFinal.module.less';

function VTCartFinal({config, methodPayment, transactionID, remoteError}) {
  const debug =  config.hasOwnProperty('debug') ? config.debug : false
  const [cart] = useState(new EMDBcart('vtformcart'));
  const {t,i18n} = useTranslation(["vtcartfinal"]);
  const language = (config.hasOwnProperty('locale')) ? config.locale : 'es';
  const [error, setError] = useState(false);
  const [bookings, setBookings] = useState([]);

  useEffect(() => {
    i18n.changeLanguage(language);
  }, [language]);

  useEffect(() => {

    async function fetchData() {
      const bookinginfo = await bookingFinal (transactionID,methodPayment);
      if (debug) console.log("[VTCartFinal]->bookinginfo",bookinginfo);
      if(!bookinginfo.error){
        //Si es correcto borramos carro
        if (bookinginfo.data.success){
          setBookings(bookinginfo.data.bookings);
          cart.deleteCart();
        }else{
          setBookings([]);
          setError(bookinginfo.data.errorcode ? bookinginfo.data.errorcode : true);
        }
      }else setError('VT'+ bookinginfo.error);
    }

    fetchData();

  }, [transactionID])

  return (
    <div className={styles.cartfinal}>
      {error &&
        <>
          <p className={styles.title_error}>{t('¡Ha ocurrido un error!')}</p>
          <p className={styles.error_code}>[Error code: {error}]</p>
          <p className={styles.text}>{t('La reserva NO se ha efectuado satisfactoriamente')}</p>
          <p className={styles.text}>{t('Revise los datos de pago e intentelo de nuevo')}</p>
          <p className={styles.text}>{t('En caso de que el error continue, por favor pongase en contacto con nosotros por teléfono o por email')}</p>
        </>
      }
      {!error &&
        <>
          <p className={styles.title}>{t('¡Gracias por su compra!')}</p>
          <p className={styles.text}>{t('La reserva se ha efectuado satisfactoriamente')}</p>
          <p className={styles.text}>{t('Estos son sus números de reserva')}</p>
          {bookings && bookings.map(booking => <li key={booking}>{booking}</li>)}
          <p className={styles.text}>{t('Recibira su ticket de compra y toda la información en su correo')}</p>
          <p className={styles.text}>{t('Si quiere modificar o cancelar su reserva pongase en contacto con nosotros por teléfono o por email')}</p>
        </>
      }
    </div>
  )
};

export default VTCartFinal;
